module.exports = __webpack_public_path__ + "static/apsca-a8e1589d96d48583ea386c578b8c91db.png";